
<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {

    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/tg2.scss";

.focusBind {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: $force-bind;
  .hint {
    @include common-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
    }
    > main {
      padding-top: 0.25rem;
      padding-bottom: 0.3rem;
      > p {
        text-align: left;
        word-wrap: break-word;
        text-indent: 2em;
        font-size: 0.24rem;
        line-height: 0.28rem;
        padding: 0 0.3rem;
        color: #585858;
        height: 2.8rem;
        overflow: auto;
        > span {
          color: #db8424;
        }
      }
      .btnGroup {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0.2rem;
        width: 100%;
        > button {
          width: 2.2rem;
          height: 0.6rem;
          border: none;
          outline: none;
          background: none;
          font-size: 0.24rem;
          border-radius: 0.66rem;
          margin: 0 0.1rem;
          &:active {
            -webkit-filter: brightness(110%);
            filter: brightness(110%);
          }
        }
        .btnCancel {
          border: 1px solid $primary-color;
          color: $primary-color;
        }
        .btnConfirm {
          background: $primary-color;
          color: #ffffff;
        }
      }
    }
    &.fullScreen {
      @include full-screen-window();
      > header {
        position: relative;
        > span {
          font-weight: 600;
          font-style: italic;
        }
      }
      > main {
        padding-top: 12px;
        padding-bottom: 15px;
        > p {
          text-align: left;
          word-wrap: break-word;
          text-indent: 2em;
          font-size: 12px;
          line-height: 14px;
          padding: 0 15px;
          color: #585858;
          height: 140px;
          overflow: auto;
          > span {
            color: #db8424;
          }
        }
        .btnGroup {
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: 10px;
          width: 100%;
          > button {
            width: 110px;
            height: 30px;
            border: none;
            outline: none;
            background: none;
            font-size: 12px;
            border-radius: 33px;
            margin: 0 5px;
            &:active {
              -webkit-filter: brightness(110%);
              filter: brightness(110%);
            }
          }
          .btnCancel {
            border: 1px solid $primary-color;
            color: $primary-color;
          }
          .btnConfirm {
            background: $primary-color;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>